import BinIcon from '../../assets/icons/bin-icon-gray-400.svg';
interface Props {
  selectedItemsCount: number;
  handleDelete: () => void;
}

const ActionBar = ({ selectedItemsCount, handleDelete }: Props) => {
  return (
    <div className='action-bar-bottom'>
      <span className='color-white'>
        <span className='font-h4-bold primary-100'>{selectedItemsCount} </span> files selected
      </span>
      <div className='button-secondary-with-icon gray-400' onClick={handleDelete}>
        <img src={BinIcon} alt='' />
        <button className='button-secondary'>Delete</button>
      </div>
    </div>
  );
};

export default ActionBar;
